// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53aba06f","453":"d4094e9f","455":"d76d8123","977":"b5a42624"}[chunkId] + ".chunk.js";
};